import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { reviewReportEnumMapProvider } from 'editing-tool/src/app/core/services/enum/review-report-enum-map';
import { reviewStatusEnumMapProvider } from 'editing-tool/src/app/core/services/enum/review-status-enum-map';
import { reviewTypeEnumMapProvider } from 'editing-tool/src/app/core/services/enum/review-type-enum-map';
import { environment } from 'editing-tool/src/environments/environment';
import { CommonCoreModule, DefaultPermissionTokenProvider, ENV_TOKEN, IdentityModule, PERMISSION_TOKEN_PROVIDER } from 'sc-common';

@NgModule(
    {
        imports: [
            CommonModule,
            CommonCoreModule,
            IdentityModule.forRoot([environment.apiUrl])
        ],
        providers: [
            {
                provide: ENV_TOKEN,
                useValue: environment
            },
            {
                provide: PERMISSION_TOKEN_PROVIDER,
                useClass: DefaultPermissionTokenProvider
            },
            reviewStatusEnumMapProvider,
            reviewReportEnumMapProvider,
            reviewTypeEnumMapProvider
        ]
    }
)
export class CoreModule {
}
